var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder2Copy = function SvgFolder2Copy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.3331095%",
    y1: "43.3311462%",
    x2: "26.3331095%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6757",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12917C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.259847%",
    y1: "27.7777778%",
    x2: "96.7051188%",
    y2: "63.6952718%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CBDA3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12917C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jbr",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Dokumenty_lista_przenies_2",
    transform: "translate(-986.000000, -569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wiersz_default",
    transform: "translate(970.000000, 561.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/folder"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L6.32075236,2 C7.0157363,2 7.66427892,2.33917989 8.06120978,2.90382444 L8.125,3 C8.51380413,3.6220866 9.19565348,4 9.92924764,4 L22,4 C23.1045695,4 24,4.8954305 24,6 L24,16 C24,17.1045695 23.1045695,18 22,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,4 C0,2.8954305 0.8954305,2 2,2 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L22,6 C23.1045695,6 24,6.8954305 24,8 L24,20 C24,21.1045695 23.1045695,22 22,22 L2,22 C0.8954305,22 0,21.1045695 0,20 L0,8 C0,6.8954305 0.8954305,6 2,6 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-2)"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder2Copy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder 2 copy.ae73bd28582fd87d7ccdf4250154abab.svg";